"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var SocialIcons = /** @class */ (function (_super) {
    __extends(SocialIcons, _super);
    function SocialIcons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildItems = function (items, settings) {
            return items
                ? items.map(function (item, i) {
                    return settings["social_link_" + item] ? (React.createElement("li", { key: i, className: "block" + (_this.props.innerClassName ? " " + _this.props.innerClassName : "") },
                        React.createElement("a", { href: settings["social_link_" + item], target: "_blank", className: "block transition-fast hover:opacity-50 text-center flex justify-center h-full", rel: "noreferrer" },
                            React.createElement(Snippets.Svg, { name: item, width: 16 })))) : null;
                })
                : [];
        };
        return _this;
    }
    SocialIcons.prototype.render = function () {
        var _a = this.props, settings = _a.settings, title = _a.title;
        var socialPlatforms = [
            "facebook",
            "instagram",
            "twitter",
            "pinterest",
            "linkedin",
            "snapchat",
            "youtube",
            "vimeo",
            "tumblr",
            "wechat"
        ];
        return socialPlatforms.filter(function (platform) { return settings["social_link_" + platform]; }).length ? (React.createElement("nav", null,
            title ? (React.createElement(Snippets.Heading, { size: "h4", className: "mb-0-8" }, title)) : null,
            React.createElement("ul", { className: "list-reset" + (this.props.className ? " " + this.props.className : "") }, this.buildItems(socialPlatforms, settings)))) : null;
    };
    return SocialIcons;
}(React.PureComponent));
exports.SocialIcons = SocialIcons;
